/* eslint-disable @typescript-eslint/no-unused-vars */
import Box from "@mui/material/Box";
import * as React from "react";
import ReactApexChart from "react-apexcharts";

export default function RecordsMiniChart({
  // expectedAmount,
  values,
  id,
}: {
  // expectedAmount?: number;
  id: string;
  values: number[];
}) {
  const [miniChartOptions] = React.useState<ApexCharts.ApexOptions>({
    series: [
      {
        name: id,
        data: values?.map((r) => r),
        color: "#05dd9f",
      },
    ],
    chart: {
      type: "area",
      id: `mini-chart-${id}`,
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      // tickAmount: "dataPoints",
    },
    yaxis: {
      show: false,
      min: Math.min(...values),
      max: Math.max(...values),
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    // annotations: {
    //   yaxis: [
    //     ...(context == RecordsMiniChartContext.RFI && expectedAmount
    //       ? [
    //           {
    //             y: expectedAmount,
    //             borderColor: "#000",
    //           },
    //         ]
    //       : []),
    //   ],
    //   points: [
    //     ...(context == RecordsMiniChartContext.PH
    //       ? records
    //           .filter((r) => r.averagePh)
    //           .map((r) => {
    //             return {
    //               x: new Date(r.date as string).getTime(),
    //               y: r.averagePh,
    //               marker: {
    //                 size: 2,
    //                 radius: 0,
    //                 fillColor: "#fff",
    //                 strokeColor: "#19daa3",
    //                 strokeWidth: 3,
    //               },
    //             };
    //           })
    //       : []),
    //   ],
    // },
  });

  return (
    <Box>
      <ReactApexChart
        options={miniChartOptions}
        series={miniChartOptions.series}
        type={"line"}
        height={60}
        width={100}
      />
    </Box>
  );
}
